import { is } from '@common/is/is'
import { Array } from '@common/Array/Array'
import { Number } from '@common/Number/Number'

import type { TRestrictionSplittedVersion } from '../definitions'

const DOT = '.'
const RESTRICTION_VERSION_LENGTH = 3

/**
 * Érték parszolása, ha alkalmas rá akkor bontjuk, ha nem, akkor visszaadjuk az eredeti értéket.
 * @param value - Parszolni kívánt érték.
 */
export default function parseRestrictionValue (value: string): TRestrictionSplittedVersion | string {
  // ha a string nem tartalmaz pontot és parseIntelve a visszatérési értéke NaN, akkor ez biza string.
  if (!value.includes(DOT) && !is.numeric(value)) {
    return value
  }

  const splitted = value.split(DOT)

  const restrictionVersion = Array.times(RESTRICTION_VERSION_LENGTH, (i) => {
    const actValue = splitted[i]

    return is.string(actValue)
      ? Number.parseInt(actValue, -1)
      : 0
  }) as TRestrictionSplittedVersion

  const nanIndex = restrictionVersion.indexOf(-1)

  // Ha az első parsolt érték NaN, akkor visszaküldjük az eredeti stringet.
  if (nanIndex === 0) {
    return value
  }
  // ha a nanIndex nagyobb, mint nulla, akkor megvágjuk.
  else if (nanIndex > 0) {
    const validNumbers = restrictionVersion.slice(0, nanIndex)

    const diff = RESTRICTION_VERSION_LENGTH - validNumbers.length

    return [ ...validNumbers, ...Array.times(diff, () => 0) ] as TRestrictionSplittedVersion
  }

  return restrictionVersion
}
